import { Fragment } from "react/jsx-runtime";
import CustomText from "../atomic/CustomText";
import Button from "../organism/Button";
import useDeleteOrder from "../../services/utils/custom hooks/OnlineOrder/useDeleteOrder";

function DeleteOrderPopup({
  orderId,
  closePopup,
}: {
  orderId: string;
  closePopup: any;
}): JSX.Element {
  const { mutate, isPending } = useDeleteOrder({
    closePopup,
  });

  return (
    <Fragment>
      <CustomText
        text="Are you sure you want to delete order?"
        fontWeight="font-normal"
        className="text-red-500"
      />
      <div className="flex items-end  justify-end mt-3">
        <Button
          textInformation={{ text: "Cancel", fontWeight: "font-semibold" }}
          onClick={closePopup}
          buttonTheme="secondary"
          className="mr-3"
        />
        <Button
          textInformation={{ text: "Yes", fontWeight: "font-semibold" }}
          onClick={() => {
            mutate(orderId);
          }}
          buttonTheme="primary"
          disabled={isPending}
          loading={isPending}
        />
      </div>
    </Fragment>
  );
}

export default DeleteOrderPopup;
